module.exports = __webpack_public_path__ + "static/media/orange-spotted-sunfish.53b08687.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/orange-spotted-sunfish.png
// module id = 326
// module chunks = 0